import { Tag } from 'antd'
import { useTranslation } from 'react-i18next'
import type { VoucherState } from './voucherStockApi'

/**
 * Rang kartaning TAQDIRINI ko'rsatadi, holat nomining og'irligini emas.
 *
 * Sherik ro'yxatga bitta savol bilan qaraydi: «bu kartani hali sota
 * olamanmi». Javob uch guruhga bo'linadi va ranglar aynan shuni
 * takrorlaydi:
 *
 *   · `NEW`, `SOLD`      — TIRIK karta (ko'k / kulrang): hali
 *     ishlatilishi mumkin, ya'ni kodi ham SIR;
 *   · `ACTIVATED`        — yashil: hammasi joyida, karta ishini qildi;
 *   · `EXPIRED`, `VOIDED` — qizil: karta yo'qolgan qiymat.
 *
 * ⚠️ `EXPIRED` va `VOIDED` bir xil rangda, lekin BOSHQA matn bilan:
 * ikkalasi ham sherik uchun bir xil oqibat (pul ketdi), lekin sabab
 * boshqa — birinchisi javonda qolib kuygan, ikkinchisini esa operator
 * ATAYLAB bekor qilgan. Rang oqibatni, matn sababni aytadi.
 */
const STATE_COLOR: Record<VoucherState, string> = {
  NEW: 'blue',
  SOLD: 'default',
  ACTIVATED: 'green',
  EXPIRED: 'red',
  VOIDED: 'red',
}

export function VoucherStateTag({ state }: { state: VoucherState }) {
  const { t } = useTranslation()
  return <Tag color={STATE_COLOR[state]}>{t(`myVouchers.state.${state}`)}</Tag>
}
